<template>
  <div class="a-disclaimer">
    <div class="a-disclaimer__heading">
      <h2>{{ headingText }}</h2>
    </div>
    <div class="a-disclaimer__content">
      <RichText :content="contentDisclaimer" class="a-disclaimer__disclaimer" />
      <RichText :content="usageRights" class="a-disclaimer__rights" />
    </div>
  </div>
</template>

<script>
import { RichText } from "@thegetty-private/getty-ui";
import { useLocalization } from "@thegetty-private/getty-ui";
import contentDisclaimerMessage from "@/data/content_disclaimer.md?raw";
import usageRightsMessage from "@/data/usage_rights.md?raw";

export default {
  name: "ContentDisclaimerAndUse",
  components: {
    RichText
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * The heading of the disclaimer and use section
       **/
      headingText: this.translatePart("copy_right_and_usage.heading"),
      /**
       * The content for the disclaimer section
       **/
      contentDisclaimer: contentDisclaimerMessage,
      /**
       * The content for the usage section
       **/
      usageRights: usageRightsMessage
    };
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
